<script setup>
  import layoutShell from '@/components/layout/layoutShell.vue';
  import LayoutFooter from '@/components/layout/layoutFooter.vue';

  import compTagsTable from '@/components/siem/compTagsTable.vue';
</script>
<template>

    <!-- Sidebar -->
    <layoutShell>

  <div class="layout-content-wrapper">
    <main class="content">
      <compTagsTable />
    </main>
  </div>
  <div class="layout-footer">
    <LayoutFooter />
  </div>
</layoutShell>
</template>



